import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as routeLink from "./../../constants/routeLink";
import { checkPercentMining, formatNumber, trups } from '../../services/services';
const Index = (props) => {
  const dispatch = useDispatch()
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;

  return (

    <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2 zIndex-10'>
      <div className='card-custom w-100 pe-2 ps-2 radius-custom d-flex justify-content-between align-items-center'>
        <div className='d-flex justify-content-center align-items-center'>
          <div className='logo '>
            <img className='w-100 h-100' src={`${routeLink.domain}/assets/nfts/${checkPercentMining(user?.balanceMining) * 1 + trups}.png`} />

          </div>
          <h4 className='text-white w-100  '>Dogx</h4>
        </div>

        <button className='btn  card-custom scale_btn text-white'>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img className='' style={{ width: 25, marginRight: 8 }} src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
            <h5 className='text-white m-0' style={{ fontSize: 16 }}>{formatNumber(user?.balanceTon)}</h5>
          </div>
        </button>
      </div>


    </div>
  )
}

export default Index;
